import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
import { tuiFormatCurrency } from '@taiga-ui/addon-commerce/utils';

class TuiCurrencyPipe {
    transform(currency) {
        return tuiFormatCurrency(currency);
    }
}
TuiCurrencyPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiCurrencyPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
TuiCurrencyPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiCurrencyPipe, name: "tuiCurrency" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiCurrencyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'tuiCurrency',
                }]
        }] });

class TuiCurrencyPipeModule {
}
TuiCurrencyPipeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiCurrencyPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiCurrencyPipeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiCurrencyPipeModule, declarations: [TuiCurrencyPipe], exports: [TuiCurrencyPipe] });
TuiCurrencyPipeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiCurrencyPipeModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiCurrencyPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TuiCurrencyPipe],
                    exports: [TuiCurrencyPipe],
                }]
        }] });

class TuiFormatCardPipe {
    transform(value = '', cardPrefilled = false) {
        return value && !cardPrefilled
            ? value
                .split('')
                .map((char, index) => (index && index % 4 === 0 ? ` ${char}` : char))
                .join('')
            : '';
    }
}
TuiFormatCardPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFormatCardPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
TuiFormatCardPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFormatCardPipe, name: "tuiFormatCard" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFormatCardPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'tuiFormatCard' }]
        }] });

class TuiFormatCardModule {
}
TuiFormatCardModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFormatCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiFormatCardModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFormatCardModule, declarations: [TuiFormatCardPipe], exports: [TuiFormatCardPipe] });
TuiFormatCardModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFormatCardModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFormatCardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TuiFormatCardPipe],
                    exports: [TuiFormatCardPipe],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiCurrencyPipe, TuiCurrencyPipeModule, TuiFormatCardModule, TuiFormatCardPipe };
